import novinLogo from './novin'
import parsianLogo from './parsian'
import pasargadLogo from './pasargad'
import samanLogo from './saman'

export {
    novinLogo,
    parsianLogo,
    pasargadLogo,
    samanLogo,
}